import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {Observable, throwError} from "rxjs";
import {environment} from "../../../environments/environment";
import { GMonInput } from 'src/app/_models/gmon-input';
import { LCInput } from 'src/app/_models/lc-input';
import { LAInput } from 'src/app/_models/la-input';
import {ReactivePowerAnalysisInput} from '../../_models/reactive-power-analysis-imput';
import { GPlanInput } from 'src/app/_models/gplan-input';
import { GridElementMeasurementInfo } from 'src/app/_models/grid-element-measurement-info';
import { PVInput } from 'src/app/_models/pv-data';
import { SCCInput } from 'src/app/_models/scc-input';
import { ThdInput } from 'src/app/_models/thd-input';
import { catchError } from 'rxjs/operators';
import { ModalService } from '../modal/modal.service';
import { ThdMonitoringService } from '../thd-monitoring-service/thd-monitoring.service';



@Injectable({
  providedIn: 'root'
})
export class GuiService {

  constructor(private httpClient: HttpClient,
    private modalService: ModalService,
    private thdMonitoringService: ThdMonitoringService
  ) { }

  public getAllNotifications(): Observable<any> {
    return this.httpClient.get(environment.API_BASE_URL +"gui/getAllNotifications");
  }

  public getInitialNotifications(): Observable<any>{
    return this.httpClient.get(environment.API_BASE_URL + "gui/getAutoExecutorNotification", { observe: 'response'})
  }

  public getDoNotShowNotifications(notificationId: number): Observable<any>{
    return this.httpClient.get(environment.API_BASE_URL + "gui/toggleNotificationsRead/" + notificationId, {observe: 'response'})
  }

  public getLastNotifications(): Observable<any> {
    return this.httpClient.get(environment.API_BASE_URL +"gui/getAllAlarms/");
  }

  public toggleNotificationRead(notificationId: number): Observable<any> {
    return this.httpClient.get(environment.API_BASE_URL + "gui/toggleNotificationsRead/" + notificationId);
  }

  public markAllNotificationsRead(): Observable<any> {
    return this.httpClient.get(environment.API_BASE_URL + "gui/markAllNotificationsRead");
  }

  public runGMon(gmonInput: GMonInput): Observable<any> {
    return this.httpClient.post(environment.API_BASE_URL + "gui/runGMon", gmonInput);
  }

  //THD Monitoring application POST request
  public runThdMonitoring(thdInput: ThdInput, failureTitle: string, failureText: string): Observable<any>{
    return this.httpClient.post(environment.API_BASE_URL + "gui/runTHD", thdInput, {observe: 'response'}).pipe(catchError((error: HttpErrorResponse) => {
      this.modalService.openBasicAlert(failureTitle, failureText);
      this.thdMonitoringService.receiveThd();
      return throwError(error);
    }));
  }

  public runPVListProcessing(loadedPVList: Array<PVInput>): Observable<any> {
    return this.httpClient.post(environment.API_BASE_URL + "gui/runPVListProcessing", loadedPVList);
  }

  public runLossCalculation(lcInput: LCInput): Observable<any> {
    return this.httpClient.post(environment.API_BASE_URL + "gui/runLC", lcInput);
  }

  public runLoadingAnalysis(laInput: LAInput): Observable<any> {
    return this.httpClient.post(environment.API_BASE_URL + "gui/runLA", laInput);
  }

  public isLicenseExpired(): Observable<any> {
    return this.httpClient.get(environment.API_BASE_URL + "gui/isLicenseExpired");
  }

  public getMeasurementData(year: Number, offset : number): Observable<any> {
    return this.httpClient.get(environment.API_BASE_URL + "gui/measurementsDates/" + year + "/" + offset);
  }

  runReactivePowerAnalysis(reactivePowerAnalysisInput: ReactivePowerAnalysisInput): Observable<any> {
    return this.httpClient.post(environment.API_BASE_URL + "gui/runRPA", reactivePowerAnalysisInput);
  }

  runGPlan(gplanInput: GPlanInput) {
    console.log("The post request content: ./", gplanInput)
    return this.httpClient.post(environment.API_BASE_URL + "gui/runGP", gplanInput, {observe: 'response'}).pipe(catchError((error: HttpErrorResponse) => {
      console.log("Gplan Finished with error: ", error)

      return throwError(error)
    }));
  }

  public getMqttConfig(): Observable<any> {
    return this.httpClient.get(environment.API_BASE_URL + "gui/mqtt/config");
  }


  public getApplicationsStatus(topologyId: string): Observable<any> {
    return this.httpClient.get(environment.API_BASE_URL + "gui/getApplicationsStatus/" + topologyId);
  }

  public getApplicationsStatusForUnderlyingTopology(topologyId: string): Observable<any>{
    return this.httpClient.get(environment.API_BASE_URL + "gui/getApplicationsStatus/" + topologyId);
  }

  public getMeasurementInfoOfNode(gridElementId: number): Observable<any> {
    return this.httpClient.get(environment.API_BASE_URL + "gui/getMeasurementInfoOfNode" + "/" + gridElementId)
  }


}
